<template>
  <el-select
    :value="value"
    @input="change"
    clearable
    placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.content"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
  export default {
    props:['type','value'],
    computed:{
      options: function(){
        return this.$store.getters['decision/getDictionaryByKey'](this.type)
      }
    },
    created() {
      if (this.type) {
        this.$store.dispatch('decision/getDictionary',{key:this.type})
      }
    },
    mounted() {
      
    },
    methods: {
      change(value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>